import { updateScoreCardDetails, createScoreCardDetails, popup } from '../../../utils';
import { ERROR } from '../../../constants';
import { isEmpty } from 'lodash';

export const handleTPASelectFn =
    ({ setSearchQuery = null, setSelectedTpa }) =>
    (item) => {
        setSearchQuery && setSearchQuery('');
        item.id !== 'all' && setSelectedTpa(item);
    };
export const handleGradeSelectFn =
    ({ setSearchQuery = null, setGrade, setShowGradeDropDown }) =>
    (item) => {
        setSearchQuery && setSearchQuery('');
        item !== 'all' ? setGrade(item) : '';
        setShowGradeDropDown && setShowGradeDropDown(false);
    };

export const handleNotesChangeFn = (setNotes) => (e) => {
    setNotes(e.target.value);
};

const checkHiringClientIdExists = (scorecards, data) => {
    return scorecards.some((scorecard) => scorecard.hiring_client_id === data.hiring_client_id);
};

export const handleSaveFn = async ({
    isEdit,
    selectedPlatform,
    selectedHiringClient,
    notes,
    selectedData,
    accountId,
    scorecards,
    selectedHiringClientGrade,
    platform_grade,
}) => {
    try {
        if (selectedHiringClient.id) {
            if (isEdit) {
                const data = {
                    ...(selectedHiringClient.id && { hiring_client_id: selectedHiringClient.id }),
                    id: selectedData.id,
                    platform_id: selectedData?.platform_id,
                    account_id: accountId,
                    notes: isEmpty(notes) ? null : notes,
                    hiring_client_grade: selectedHiringClientGrade
                        ? selectedHiringClientGrade
                        : null,
                };

                const res = await updateScoreCardDetails({ updatedData: data });
                if (res.status === 'success') {
                    return { success: true, type: 'update' };
                }
                popup('error', res.message);
                return { success: false };
            } else {
                const data = {
                    ...(selectedHiringClient?.id && { hiring_client_id: selectedHiringClient.id }),
                    platform_id: selectedPlatform?.id,
                    account_id: accountId,
                    notes: isEmpty(notes) ? null : notes,
                    hiring_client_grade: selectedHiringClientGrade
                        ? selectedHiringClientGrade
                        : null,
                    platform_grade,
                };

                const isHiringClientExists = checkHiringClientIdExists(scorecards, data);

                if (!isHiringClientExists) {
                    const res = await createScoreCardDetails({ data });

                    if (res.status === 'success') {
                        return {
                            success: true,
                            type: 'create',
                        };
                    }

                    popup('error', res.message);
                    return { success: false };
                } else {
                    popup('error', ERROR.HIRING_CLIENT_ALREADY_EXISTS);
                    return { success: false };
                }
            }
        } else {
            popup('error', ERROR.NO_HIRING_CLIENT_SELECTED);
            return { success: false };
        }
    } catch (error) {
        console.error(error);
        popup('error', error.message);
        return { success: false };
    }
};

export const scorecardCsvHeaderMap = {
    account_name: 'Client',
    csm_name: 'CSM',
    grade: 'Grade',
    platform_name: 'Platform',
    updated_by: 'Updated By',
    created_by: 'Created By',
};

export const clientCsvHeaderMap = {
    name: 'Company Name',
    email: 'Email',
    phone: 'Phone',
    csm_name: 'CSM',
    sales_agent_name: 'Sales Agent',
    platforms: 'Platforms',
    source: 'Created By',
    updated_by: 'Updated By',
};